import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { LinkTo } from '@ember/routing';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import MonogramOrPhoto from 'garaje/components/monogram-or-photo';
import TruncateWithTooltip from 'garaje/components/truncate-with-tooltip';
import type VisitorProfile from 'garaje/models/visitor-profile';
import type MetricsService from 'garaje/services/metrics';

interface NameCellSignature {
  Args: {
    row: VisitorProfile;
  };
}

export default class NameCell extends Component<NameCellSignature> {
  @service declare metrics: MetricsService;

  @action
  trackNameCellClick(): void {
    this.metrics.trackEvent('Visitors Profiles Directory Table Name Cell Click', {
      visitor_profile_id: this.args.row.id,
    });
  }

  <template>
    <LinkTo
      @route="visitors.profiles.show"
      @model={{@row.id}}
      class="group flex align-top hover:cursor-pointer hover:no-underline text-carbon-50"
      {{on "click" this.trackNameCellClick}}
      data-test-name-cell
    >
      <div class="inline-block mr-3">
        <MonogramOrPhoto @name={{@row.displayName}} @passportPhoto={{@row.photoUrl}} @borderBottom={{false}} />
      </div>
      <div class="flex flex-col justify-center pt-1">
        <span
          data-test-name-cell-name
          class="text-carbon-70 font-bold text-base group-hover:text-red-50 group-hover:underline"
        >
          {{@row.displayName}}
        </span>
        {{#if @row.primaryEmail}}
          <span data-test-name-cell-email class="text-carbon-50 font-normal block">
            <TruncateWithTooltip @value={{@row.primaryEmail}} @length={{25}} @side="bottom" />
          </span>
        {{/if}}
      </div>
    </LinkTo>
  </template>
}
